import React, { PropsWithChildren } from 'react';

import clsxm from '@/lib/clsxm';

export type FilledCard = PropsWithChildren<{
  className?: string;
}>;

const FilledCard: React.FC<FilledCard> = ({ children, className }) => {
  return (
    <div
      className={clsxm(
        'flex w-full flex-col rounded-3xl bg-ds-grey-50 pb-1',
        className
      )}
    >
      {children}
    </div>
  );
};

export default FilledCard;
